module.exports = __webpack_public_path__ + "static/cocoa-3f31a35d2fdad09870a6c222088e4a60.png";